/**
 * IWCE assist (iframe) notifies the embedding page to tear down the overlay.
 * The parent must verify `event.source === iframe.contentWindow` before acting.
 */
export const MS_IWCE_ASSIST_CLOSE_MESSAGE = "MS_IWCE_ASSIST_CLOSE" as const;
